<script setup>
import { computed } from "vue";
import { useGlobalStore } from "@stores/global.js";
import { useShopifyStore } from "@stores/shopify.js";
import Button from "@components/global/Button.vue";

const global = useGlobalStore();
const shopify = useShopifyStore();

const collections = computed(() => shopify.homepageFeaturedCollections);
</script>

<template>
	<section v-if="collections.length > 0" class="mb-48 lg:mb-80">
		<div class="grid lg:grid-cols-2">
			<div
				class="group text-text-inverted relative isolate flex aspect-square items-end overflow-hidden p-16 before:absolute before:inset-0 before:-z-1 before:size-full before:bg-linear-to-t before:from-black/50 before:to-transparent md:p-24 lg:p-48"
				v-for="collection in collections"
				:key="collection.id"
				:collection="collection"
				@mouseenter="
					if (global.pointerFine) {
						global.setHeaderTheme(
							collection.theme?.background,
							collection.theme?.accent,
							collection.theme?.surface,
						);
						$event.currentTarget.style.setProperty(
							'--card-accent',
							collection.theme?.accent,
						);
						$event.currentTarget.style.setProperty(
							'--card-background',
							collection.theme?.background,
						);
					}
				"
				@mouseleave="
					global.setHeaderTheme(null, null, null);
					$event.currentTarget.style.removeProperty('--card-accent');
					$event.currentTarget.style.removeProperty('--card-background');
				"
			>
				<img
					:src="collection.image"
					:alt="collection.image_alt || collection.title"
					class="absolute inset-0 -z-2 size-full object-cover transition-transform duration-500 group-hover:scale-105"
				/>
				<div class="flex flex-col items-start gap-24">
					<div class="flex flex-col gap-12">
						<h2 class="h4 font-primary-condensed">
							{{ collection.title }}
						</h2>
						<p class="body-md" v-if="collection.description">
							{{ collection.description }}
						</p>
					</div>
					<Button
						:to="{
							name: 'collection',
							params: { slug: collection.slug },
						}"
						class="box-link -card-theme"
					>
						View Collection
					</Button>
				</div>
			</div>
		</div>
	</section>
</template>
